import { atom } from 'nanostores';

const authState = atom({
  userName: '',
  userId: '',
});

export default authState;
